<template>
<el-dialog  title="生成二维码" :close-on-click-modal="false" :close-on-press-escape="false"  @close="closeDialog"  :visible="shengmaFlag" width="90%" center>
  <div class="inpBox">
  <el-form :inline="true" ref="goodform" enctype="multipart/form-data" :model="goodform" :rules="rules"  class="demo-form-inline jiaoyan" label-width="110px" size="mini">
    <el-form-item label="订单号:" prop="measuringUnit">
      <div>{{rowData.orderNo}} </div>
    </el-form-item>
    <br>
    <el-form-item label="剩余量:" prop="measuringUnit">
      <div>{{rowData.productTypeName}}/
        <span v-if="rowData.residualWeight"><span class="red">{{rowData.residualWeight}}</span>吨</span>
        <span v-if="rowData.residualWeight&&(rowData.residualNumber||rowData.residualVolumn)">/</span>
        <span v-if="rowData.residualNumber"><span class="red">{{rowData.residualNumber}}</span>件</span>
        <span v-if="rowData.residualNumber&&rowData.residualVolumn">/</span>
        <span v-if="rowData.residualVolumn"><span class="red">{{rowData.residualVolumn}}</span>方</span>
      </div>
    </el-form-item>
     <el-form-item label="单车重量(吨):"  prop="bicycleWeight" :rules="goodform.measuringUnit=='吨'||goodform.dun?rules.bicycleWeight:[{required: false}]" >
      <el-input  placeholder="" v-number-input.float="3" maxlength="8"  v-model="goodform.bicycleWeight"
      class="width2"  @change="orderWeightFn($event,'吨')"></el-input>
    </el-form-item>
    <el-form-item label="单车数量(件):" prop="bicycleNumber" :rules="goodform.measuringUnit=='件'||goodform.jian?rules.bicycleNumber:[{required: false}]">
      <el-input  placeholder="" v-number-input.float="0" maxlength="8"  v-model="goodform.bicycleNumber"
      class="width2"   @change="orderWeightFn($event,'件')"></el-input>
    </el-form-item>
    <el-form-item label="单车体积(方):" prop="bicycleVolumn" :rules="goodform.measuringUnit=='方'||goodform.fang?rules.bicycleVolumn:[{required: false}]" >
      <el-input  placeholder="" v-number-input.float="3" maxlength="8"  v-model="goodform.bicycleVolumn"
      class="width2"   @change="orderWeightFn($event,'方')"></el-input>
    </el-form-item>
    <div style="margin-top:20px" class="addressBox" >
      <h4 class="title">
        <span><i class="fa fa-cubes iconFont" aria-hidden="true"></i>承运信息</span>
      </h4>
      <el-table :data="[{}]"  ref="table"  bordersize="mini" class="tableBox" style="" max-height="500px"  center border>
      <el-table-column label="承运商" min-width="120">
         <template slot="header" >
          <div><span class="red">*</span>承运商</div>
        </template>
        <template slot-scope="scope">
          <div class="skfBox">
            <el-form-item label="" class="table_error"  prop="generalCarrier">
              <el-select  v-model="goodform.generalCarrier" filterable placeholder="请选择" clearable   @change="generalCarrierChange">
                <el-option v-for="item in CYSList" :label="item.customerName" :value="item.customerName" :key="item.id"></el-option>
              </el-select>
            </el-form-item>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="推送网货" min-width="100">
        <template slot-scope="scope">
          <div>
            <el-form-item label=""     class="table_error" >
              <div v-if="goodform.onlineFlag==1" >
                <el-select  v-model="goodform.onlineFreightFlag"  placeholder="请选择" clearable    @change="TSWHchange"  >
                  <el-option label="是" :value="1" ></el-option>
                  <el-option label="否" :value="0" ></el-option>
                </el-select>
              </div>
              <span v-else>-</span>
            </el-form-item>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="服务费计算" min-width="100">
        <template slot-scope="scope">
          <div>
            <el-form-item label=""   class="table_error" >
              <div v-if="goodform.generalCarrier">
                  <el-select  v-model="goodform.reverseCountFlag"  placeholder="请选择" clearable    >
                  <el-option label="反算" value="1" ></el-option>
                  <el-option label="正算" value="0" ></el-option>
                </el-select>
              </div>
              <span v-else>-</span>
            </el-form-item>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="收款方类型" min-width="100">
        <template slot="header" >
          <div><span class="red">*</span>收款方类型</div>
        </template>
        <template slot-scope="scope">
          <div>
            <div>
              <el-form-item label="" prop="payCustomerName" v-if="goodform.generalCarrier">
                {{['企业','司机','车队长'][goodform.collectionType-1]}}
              </el-form-item>
              <el-form-item label="" v-else prop="collectionType" :rules="rules.collectionType"  class="table_error">
                <el-select  v-model="goodform.collectionType"  placeholder="请选择" clearable    @change="collectionTypeFn">
                  <el-option label="企业" :value="1" ></el-option>
                  <el-option label="司机" :value="2" ></el-option>
                  <el-option label="车队长" :value="3" ></el-option>
                </el-select>
              </el-form-item>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="收款方" min-width="120">
        <template slot="header" >
          <div><span class="red">*</span>收款方</div>
        </template>
        <template slot-scope="scope">
          <div class="skfBox">
            <el-form-item label="" prop="payCustomerName" v-if="goodform.generalCarrier">
              {{goodform.generalCarrier}}
            </el-form-item>
            <el-form-item label="" :prop="payer" :rules="[{ required: true, message: '请选择收款方', trigger: 'blur' }]" class="width1 table_error" v-else-if="goodform.collectionType==1&&!goodform.generalCarrier">
              <el-select  v-model="goodform.payer" filterable placeholder="请选择"  @change="payerChange">
                <el-option v-for="item in CYSList" :label="item.customerName" :value="item.customerName" :key="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="" label-width="120px"  v-else-if="goodform.collectionType==2">
              -
            </el-form-item>
            <div v-else-if="goodform.collectionType==3">
              <el-form-item label=""  :prop="payer"  :rules="rules.payer" label-width="120px"  >
                <el-autocomplete class="inline-input" v-model.trim="goodform.payer"  placeholder="车队长姓名"
                    :fetch-suggestions="querySearch" value-key="payerTaxId" @select="handleSelect" popper-class="xiala">
                      <template slot-scope="{ item }">
                          <div style="position: relative;">
                          <div class="name">{{ item.payer }} / {{ item.payerTaxId? item.payerTaxId:''}}</div>
                        </div>
                    </template>
                </el-autocomplete>
              </el-form-item>
              <el-form-item label="" :prop="goodform.payerTaxId"  :rules="rules.payerTaxId" label-width="120px">
                <el-input  placeholder="身份证号"    maxlength="50" v-model="goodform.payerTaxId"  ></el-input>
              </el-form-item>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="支出方式" min-width="100">
        <template slot="header" >
          <div><span class="red">*</span>支出方式</div>
        </template>
        <template slot-scope="scope">
          <div>
            <el-form-item label=""  prop="expenditurePattern" :key="scope.$index" :rules="rules.expenditurePattern"  class="table_error">
              <el-select  v-model="goodform.expenditurePattern"  placeholder="请选择"  @change="zcfsChange">
                <el-option v-for="item in ZHFSlist"  :label="item.showName" :value="item.itemNo" :key="item.id"></el-option>
              </el-select>
            </el-form-item>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="运费计价" min-width="100">
        <template slot="header" >
          <div><span class="red">*</span>运费计价</div>
        </template>
        <template slot-scope="scope">
          <div>
            <el-form-item label="" prop="freightPricingType"  :rules="rules.freightPricingType"  class="table_error">
              <el-select  v-model="goodform.freightPricingType"  placeholder="请选择" @change="jijiaChange">
                <template  v-for="item in SRJJlist">
                     <el-option  :label="item.showName" v-if="item.showName.includes(goodform.measuringUnit)||item.showName=='包干'" :value="item.itemNo" :key="item.id"></el-option>
                </template>
              </el-select>
            </el-form-item>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="运费单价" min-width="100">
        <template slot="header" >
          <div><span class="red">*</span>运费单价</div>
        </template>
        <template slot-scope="scope">
          <div>
            <el-form-item label="" prop="freightUnitPrice" :key="scope.$index" :rules="rules.freightUnitPrice"  v-if="goodform.freightPricingType!=1"  class="table_error">
              <el-input  placeholder=""  v-number-input.float="2" maxlength="8" v-model="goodform.freightUnitPrice"  ></el-input>
            </el-form-item>
            <span v-else>-</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="运费金额(元)" min-width="120">
        <template slot="header" >
          <div><span class="red">*</span>运费金额(元)
          </div>
        </template>
        <template slot-scope="scope">
          <div>
            <el-form-item label=""  prop="freightAmount" :key="scope.$index" :rules="rules.freightAmount"  class="table_error">
              <el-input  placeholder=""  v-number-input.float="2" maxlength="8" v-model="goodform.freightAmount"  ></el-input>
            </el-form-item>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="服务费率%" min-width="100">
        <template slot="header" >
          <div><span class="red">*</span>服务费率%</div>
        </template>
        <template slot-scope="scope">
          <div>
            <el-form-item label=""   prop="serviceRate" :key="scope.$index" :rules="rules.serviceRate"  class="table_error">
              <el-input  placeholder=""  v-number-input.float="2" maxlength="8" v-model="goodform.serviceRate"  ></el-input>
            </el-form-item>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="运费税率%" min-width="100">
        <template slot="header" >
          <div><span class="red">*</span>运费税率%</div>
        </template>
        <template slot-scope="scope">
          <div>
            <el-form-item label="" prop="freightTaxRate" :key="scope.$index" :rules="rules.freightTaxRate"  class="table_error">
              <el-input  placeholder=""  v-number-input.float="2" maxlength="8" v-model="goodform.freightTaxRate"  ></el-input>
            </el-form-item>
          </div>
        </template>
      </el-table-column>
    </el-table>
    </div>
    <div class="dibu" v-if="goodform.updateUser">
      <el-form-item label="最近编辑人:">
        <div>{{goodform.updateUser}} </div>
      </el-form-item>
      <el-form-item label="最近更新时间:" label-width="110px">
        <div>{{goodform.updateTime|dateFormat}} </div>
      </el-form-item>
    </div>
  </el-form>
  </div>
  <span slot="footer" class="dialog-footer">
    <el-button  @click="closeDialog">取消</el-button>
    <el-button type="primary" @click="saveFn">提交</el-button>
  </span>
</el-dialog>
</template>
<script>
import { selectTMSTenantListByCustom } from '@/api/newCrm'
import { checkRequiredFields, getDictionaryDetailList, findCustomerInfoList, getCustomerTaxRate, pushWayToWHPTFlag,
  findVehicleLeaderList, rawCode, orderQrCodeDetail } from '@/api/newTMS'
import { toFixed } from '@/utils/util'
export default {
  name: 'xiugaiSG',
  props: {
    shengmaFlag: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      goodform: {
        measuringUnit: this.rowData.measuringUnit,
        orderWeight: this.rowData.orderWeight,
        orderId: this.rowData.orderId,
        orderNo: this.rowData.orderNo,
        orderBusinessId: this.rowData.orderBusinessId,
        id: this.rowData.orderQrCodeId
      },
      rowData1: { ...this.rowData },
      rules: {
        bicycleWeight: [
          { required: true, message: '请输入重量', trigger: 'blur' }
        ],
        bicycleVolumn: [
          { required: true, message: '请输入体积', trigger: 'blur' }
        ],
        bicycleNumber: [
          { required: true, message: '请输入数量', trigger: 'blur' }
        ],
        number: [
          { required: true, message: '请输入数量', trigger: 'blur' }
        ],
        payer: [
          { required: true, message: '车队长名称', trigger: 'blur' }
        ],
        payerTaxId: [
          { required: true, message: '请输入身份证号', trigger: 'blur' }
        ],
        expenditurePattern: [
          { required: true, message: '请选择支出方式', trigger: 'blur' }
        ],
        freightPricingType: [
          { required: true, message: '请选择运费计价', trigger: 'blur' }
        ],
        freightUnitPrice: [
          { required: true, message: '请输入运费单价', trigger: 'blur' }
        ],
        freightAmount: [
          { required: true, message: '请输入运费金额', trigger: 'blur' }
        ],
        serviceRate: [
          { required: true, message: '请输入服务费率', trigger: 'blur' }
        ],
        serviceCharge: [
          { required: true, message: '请输入服务费', trigger: 'blur' }
        ],
        freightTaxRate: [
          { required: true, message: '请输入运费税率', trigger: 'blur' }
        ],
        generalCarrier: [
          { required: true, message: '请选择承运商', trigger: 'blur' }
        ]
      },
      ZHFSlist: [],
      SRJJlist: [],
      CYSList: []
    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    if (this.rowData.orderQrCodeId) {
      orderQrCodeDetail({ id: this.rowData.orderQrCodeId }).then(res => {
        this.goodform = res
        this.goodform.measuringUnit = this.rowData.measuringUnit
        this.goodform.orderId = this.rowData.orderId
        this.goodform.orderNo = this.rowData.orderNo
        this.goodform.orderBusinessId = this.rowData.orderBusinessId

        this.$set(this.goodform, 'freightUnitPrice', res.freightUnitPrice / 100)
        this.$set(this.goodform, 'freightAmount', res.freightAmount / 100)

        this.$set(this.goodform, 'onlineFreightFlag', Number(res.onlineFreightFlag))
        let danwei = this.rowData.measuringUnit
        if (danwei == '吨') {
          this.$set(this.goodform, 'orderWeight', this.goodform.bicycleWeight)// 为了算钱
        } else if (danwei == '件') {
          this.$set(this.goodform, 'orderWeight', this.goodform.bicycleNumber)
        } else if (danwei == '方') {
          this.$set(this.goodform, 'orderWeight', this.goodform.bicycleVolumn)
        }
        // 判断是否推送网货是否显示
        findCustomerInfoList({ businessType: 2 }).then(res => {
          selectTMSTenantListByCustom(res).then(res1 => {
            this.CYSList = res1
            let json = this.CYSList.filter(item => item.customerName == this.goodform.generalCarrier)
            if (json.length > 0) {
              this.$set(this.goodform, 'onlineFlag', json[0].onlineFlag)
            } else {
              this.$set(this.goodform, 'onlineFlag', null)
            }
          })
        })
      })
    } else {
      findCustomerInfoList({ businessType: 2 }).then(res => {
        selectTMSTenantListByCustom(res).then(res1 => { this.CYSList = res1 })
      })
    }
    this.getflagFn()
    getDictionaryDetailList({ dictionaryType: 'down_settlement_type' }).then(res => { this.ZHFSlist = res })
    getDictionaryDetailList({ dictionaryType: 'settlement_pricing' }).then(res => { this.SRJJlist = res })
  },
  methods: {
    saveFn () {
      let danwei = this.rowData.measuringUnit
      if (danwei == '吨') {
        if (this.goodform.bicycleWeight && this.goodform.bicycleWeight > this.rowData.residualWeight) {
          this.$alert('输入的重量不能大于剩余重量', '系统提示')
          return
        }
      } else if (danwei == '件') {
        if (this.goodform.bicycleNumber && this.goodform.bicycleNumber > this.rowData.residualNumber) {
          this.$alert('输入的数量不能大于剩余数量', '系统提示')
          return
        }
      } else if (danwei == '方') {
        if (this.goodform.bicycleVolumn && this.goodform.bicycleVolumn > this.rowData.residualVolumn) {
          this.$alert('输入的体积不能大于剩余体积', '系统提示')
          return
        }
      }
      this.$refs.goodform.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          rawCode(this.goodform).then(res => {
            loading.close()
            this.rowData1.orderQrCodeId = res
            this.$emit('update:shengmaFlag', false)
            this.$parent.erweimaFn(this.rowData1)
            this.$parent.searchFn()
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }
      })
    },
    // 货物重量改变
    orderWeightFn (e, danwei) {
      if (e != '' && Number(e) === 0) {
        this.$alert('输入的值不能为0', '系统提示')
        if (danwei == '吨') {
          this.$set(this.goodform, 'bicycleWeight', '')
        } else if (danwei == '件') {
          this.$set(this.goodform, 'bicycleNumber', '')
        } else if (danwei == '方') {
          this.$set(this.goodform, 'bicycleVolumn', '')
        }
      } else {
        if (danwei == '吨') {
          if (this.goodform.bicycleWeight && this.goodform.bicycleWeight > this.rowData.residualWeight) {
            this.$alert('输入的重量不能大于剩余重量', '系统提示')
            this.$set(this.goodform, 'bicycleWeight', '')
          }
          this.$set(this.goodform, 'orderWeight', this.goodform.bicycleWeight)// 为了算钱
        } else if (danwei == '件') {
          if (this.goodform.bicycleNumber && this.goodform.bicycleNumber > this.rowData.residualNumber) {
            this.$alert('输入的数量不能大于剩余数量', '系统提示')
            this.$set(this.goodform, 'bicycleNumber', '')
          }
          this.$set(this.goodform, 'orderWeight', this.goodform.bicycleNumber)
        } else if (danwei == '方') {
          if (this.goodform.bicycleVolumn && this.goodform.bicycleVolumn > this.rowData.residualVolumn) {
            this.$alert('输入的体积不能大于剩余体积', '系统提示')
            this.$set(this.goodform, 'bicycleVolumn', '')
          }
          this.$set(this.goodform, 'orderWeight', this.goodform.bicycleVolumn)
        }
      }
    },
    // 支出方式修改
    zcfsChange (e) {
      let json = this.ZHFSlist.filter(item => item.itemNo == e)
      this.goodform.expenditurePatternName = json[0].showName
    },
    // 运费计价修改
    jijiaChange (e) {
      let json = this.SRJJlist.filter(item => item.itemNo == e)
      this.goodform.freightPricingTypeName = json[0].showName
      if (this.goodform.freightPricingType == 1) {
        this.$set(this.goodform, 'freightUnitPrice', '')
        this.$set(this.goodform, 'freightAmount', '')
      } else {
        this.$set(this.goodform, 'freightUnitPrice', '')
        this.$set(this.goodform, 'freightAmount', '')
      }
    },
    // 车队长查询
    querySearch (str, cb) {
      findVehicleLeaderList({ payer: str }).then(res => {
        cb(res)
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
          }
        })
      })
    },
    handleSelect (e) {
      this.$set(this.goodform, 'payer', e.payer)
      this.$set(this.goodform, 'payerTaxId', e.payerTaxId)
    },
    // 收款方类型改变
    collectionTypeFn (e) {
      if (e == 2) {
        this.$set(this.goodform, 'payer', this.goodform.driverName)
        this.$set(this.goodform, 'payerTaxId', this.goodform.idNumber)
        this.$set(this.goodform, 'payerCode', '')
      } else {
        this.$set(this.goodform, 'payer', '')
        this.$set(this.goodform, 'payerTaxId', '')
        this.$set(this.goodform, 'payerCode', '')
      }
    },
    // 收款方改变
    payerChange (e) {
      let json = this.CYSList.filter(item => item.customerName == this.goodform.payer)
      this.goodform.payerTaxId = json[0].customerTaxId
      this.goodform.payerCode = json[0].tenantCode
    },
    // 推送网货改变
    TSWHchange () {
      let json = this.CYSList.filter(item => item.customerName == this.goodform.generalCarrier)
      this.whLuoji(json)
    },
    // 推送网货逻辑
    whLuoji (json) {
      if (this.goodform.onlineFreightFlag == 1) {
        pushWayToWHPTFlag().then(res => {
          if (res) {
            this.$set(this.goodform, 'WHJKflag', true)
            getCustomerTaxRate({ orderBusinessId: this.goodform.orderBusinessId ? this.goodform.orderBusinessId : null }).then(res => {
              this.$set(this.goodform, 'serviceRate', res * 100)
            }).catch(error => {
              this.$set(this.goodform, 'serviceRate', null)
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                }
              })
            })
          } else {
            this.$set(this.goodform, 'WHJKflag', false)
            this.$set(this.goodform, 'serviceRate', json[0].serviceRate)
          }
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
            }
          })
        })
      } else {
        this.$set(this.goodform, 'WHJKflag', false)
        this.$set(this.goodform, 'serviceRate', json[0].serviceRate)
      }
    },
    // 承运商改变
    generalCarrierChange (e) {
      if (e) {
        let json = this.CYSList.filter(item => item.customerName == this.goodform.generalCarrier)
        this.goodform.generalTaxId = json[0].customerTaxId
        this.goodform.generalCode = json[0].tenantCode
        this.goodform.generalPeriodDays = json[0].periodDays
        this.goodform.generalInvoiceDays = json[0].invoiceDays
        this.goodform.generalPeriodDaysType = json[0].periodDaysType
        this.$set(this.goodform, 'payer', this.goodform.generalCarrier)
        this.$set(this.goodform, 'payerTaxId', json[0].customerTaxId)
        this.$set(this.goodform, 'payerCode', json[0].tenantCode)
        this.$set(this.goodform, 'collectionType', 1)
        this.$set(this.goodform, 'onlineFlag', json[0].onlineFlag)
        this.$set(this.goodform, 'onlineFreightFlag', json[0].onlineFreightFlag)
        this.$set(this.goodform, 'reverseCountFlag', json[0].reverseCountFlag)
        this.$set(this.goodform, 'expenditurePattern', json[0].settlementType)
        this.$set(this.goodform, 'expenditurePatternName', json[0].settlementTypeName)
        this.$set(this.goodform, 'freightTaxRate', json[0].taxRate)
        this.whLuoji(json)
      } else {
        this.$set(this.goodform, 'onlineFreightFlag', null)
        this.$set(this.goodform, 'reverseCountFlag', null)
        this.$set(this.goodform, 'serviceRate', 0)
        this.goodform.generalTaxId = null
        this.goodform.generalCode = null
        this.goodform.generalPeriodDays = null
        this.$set(this.goodform, 'payer', null)
        this.$set(this.goodform, 'payerTaxId', null)
        this.$set(this.goodform, 'payerCode', null)
        this.goodform.generalPeriodDaysType = ''
        this.$set(this.goodform, 'WHJKflag', false)
      }
    },
    // 判断吨件方是否必填
    getflagFn () {
      if (this.goodform.payee && this.goodform.kilometres && this.goodform.productTypeName) {
        checkRequiredFields({
          itemNo: this.goodform.payee,
          showName: this.goodform.productTypeName,
          kilometres: this.goodform.kilometres
        }).then(res => {
          this.$set(this.goodform, 'dun', res.weight)
          this.$set(this.goodform, 'jian', res.number)
          this.$set(this.goodform, 'fang', res.volumn)
        })
      }
    },
    closeDialog () {
      this.$emit('update:shengmaFlag', false)
    }
  },
  watch: {
    goodform: {
      handler (newName, oldName) {
        if (this.goodform.orderWeight && this.goodform.freightUnitPrice) {
          this.$set(this.goodform, 'freightAmount', toFixed(accMul(this.goodform.orderWeight, this.goodform.freightUnitPrice), 2))
        }
        // 网货反算。服务费 = 运费/（1-服务费率）* 服务费率  合计 = 运费 /（1-服务费率）
        // if (this.goodform.reverseCountFlag == 1) {
        //   if (this.goodform.freightAmount && this.goodform.serviceRate) {
        //     let n = this.goodform.serviceRate / 100
        //     this.$set(this.goodform, 'serviceCharge', toFixed(this.goodform.freightAmount / (1 - n) * n, 2))
        //   } else {
        //     this.$set(this.goodform, 'serviceCharge', 0)
        //   }
        // } else {
        //   if (this.goodform.freightAmount && this.goodform.serviceRate) {
        //     let n = this.goodform.serviceRate / 100
        //     this.$set(this.goodform, 'serviceCharge', toFixed(accMul(this.goodform.freightAmount, n), 2))
        //   } else {
        //     this.$set(this.goodform, 'serviceCharge', 0)
        //   }
        // }
        function accMul (arg1, arg2) {
          var m = 0; var s1 = arg1.toString(); var s2 = arg2.toString()
          try {
            m += s1.split('.')[1].length
          } catch (e) {
          }
          try {
            m += s2.split('.')[1].length
          } catch (e) {
          }

          return Number(s1.replace('.', '')) * Number(s2.replace('.', '')) / Math.pow(10, m)
        }
      },
      deep: true
    }
  }

}
</script>

<style scoped lang='less'>
/deep/.el-input__inner{
  width: 100px;
}
.dibu{
  text-align: right;
  margin-top: 20px;
  color: #837c7c !important;
  /deep/.el-form-item__label{
    color: #837c7c;
  }
}
.skfBox{
  /deep/.el-input__inner {
    width: 100%;
}
}
</style>
